import { render, staticRenderFns } from "./Comparative.vue?vue&type=template&id=ed79076a"
import script from "./Comparative.vue?vue&type=script&lang=js"
export * from "./Comparative.vue?vue&type=script&lang=js"
import style0 from "./Comparative.vue?vue&type=style&index=0&id=ed79076a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports